module.exports = __webpack_public_path__ + "static/media/hermes@2x.42ba9849.png";